import { AppointmentTypesTypes } from '@frontend/api-appointment-types';
import { LeadTime } from './LeadTime';
import { RequiredApptTimes } from './RequiredApptTimes';
import * as styles from './styles';

interface Props {
  numOfApptTypes: number;
  apptRequestConfig?: AppointmentTypesTypes.ApptRequestConfig;
  apptReqConfigIsLoading: boolean;
  apptReqConfigFetchError: boolean;
  updateMinOpenings: (minOpeningsPermitted: number) => void;
  updateLeadTime: (requestBufferDuration: number) => void;
  setReqNumInputValue: (inputValue: number) => void;
}

export const ApptTypeSettings = ({
  numOfApptTypes,
  apptRequestConfig,
  apptReqConfigIsLoading,
  apptReqConfigFetchError,
  updateMinOpenings,
  updateLeadTime,
  setReqNumInputValue,
}: Props) => {
  return (
    <section css={styles.wrapper}>
      <LeadTime
        numOfApptTypes={numOfApptTypes || 0}
        apptReqConfigIsLoading={apptReqConfigIsLoading}
        apptReqConfigFetchError={apptReqConfigFetchError}
        requestBufferDuration={apptRequestConfig?.requestBufferDuration || 0}
        updateLeadTime={updateLeadTime}
      />

      <RequiredApptTimes
        numOfApptTypes={numOfApptTypes || 0}
        apptReqConfigIsLoading={apptReqConfigIsLoading}
        apptReqConfigFetchError={apptReqConfigFetchError}
        minOpeningsPermitted={apptRequestConfig?.minOpeningsPermitted || 1}
        updateMinOpenings={updateMinOpenings}
        setReqNumInputValue={setReqNumInputValue}
      />
    </section>
  );
};
